import { render, staticRenderFns } from "./DocumentViewerPlaceholder.vue?vue&type=template&id=9b10d0fe&"
import script from "./DocumentViewerPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewerPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports